import './hero.less'

import React, {Fragment, HTMLProps} from 'react'
import {LinkType, WysiwygType} from 'types'
import {Mod, style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Inpagenav} from 'views/layout/inpagenav'
import {Theme} from 'views/theme'

const styles = style('hero')

export type HeroType = {
	pagetitle?: string
	title?: string
	title_size?: Mod<'normal' | 'large'>
	mod: Mod<'profile'>
	subtitle?: string
	text?: WysiwygType
	button?: LinkType
	inpagenav?: Array<LinkType>
}

export const Hero: React.FC<HTMLProps<HTMLDivElement> & HeroType> = ({
	pagetitle,
	title,
	title_size = 'normal',
	subtitle,
	mod,
	text,
	button,
	inpagenav
}) => {
	return (
		<div className={styles().mod(mod)}>
			<Theme.OuterContainer>
				<span className={styles('stuff')} />
				<Theme.Container>
					<div className={styles('content')}>
						<div className={styles('content-top')}>
							<h1 className={styles('content-top-title').mod(title_size)}>
								<Trusted>{title || pagetitle}</Trusted>
							</h1>
							{subtitle && (
								<Fragment>
									<br />
									<h2 className={styles('content-top-subtitle')}>{subtitle}</h2>
								</Fragment>
							)}
						</div>
						{text && (
							<div className={styles('content-text')}>
								<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
							</div>
						)}
						{button && button.url && (
							<div className={styles('content-button')}>
								<Theme.Button to={button.url} mod={['gradient', 'uppercase']}>
									<Theme.ButtonText>
										{button.description || button.title}
									</Theme.ButtonText>
									<Theme.ButtonIcon icon="arrow-long" />
								</Theme.Button>
							</div>
						)}
						{inpagenav && inpagenav.length !== 0 && (
							<div className={styles('content-inpagenav')}>
								<Inpagenav links={inpagenav} />
							</div>
						)}
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}
